import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';
import qs from 'qs';

const tabTitle = window.location.host.includes('watchdog')
  ? 'WatchDog'
  : 'Highway';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login/Email.vue'),
    meta: { pageTitle: 'Login', doesNotRequireAuthentication: true },
  },
  {
    path: '/required-information',
    name: 'Required Information',
    component: () => import('../views/Login/PendingUserInfo.vue'),
    meta: { pageTitle: 'Required Information', allowAuthentication: true },
  },
  {
    path: '/idv-failed-verification',
    name: 'IDVFailedVerification',
    component: () => import('../views/IDVFailedVerification.vue'),
    meta: {
      pageTitle: 'IDV Failed Verification',
      allowAuthentication: true,
    },
  },
  {
    path: '/login/code',
    name: 'LoginVerification',
    component: () => import('../views/Login/Verification.vue'),
    meta: {
      pageTitle: 'Login Verification',
      doesNotRequireAuthentication: true,
      checkUserAndCompanyDetails: true,
    },
  },
  {
    path: '/security',
    name: 'Security',
    component: () => import('../views/Security.vue'),
    meta: { pageTitle: 'Security', doesNotRequireAuthentication: true },
  },
  {
    path: '/sign-up',
    name: 'SignUp',
    component: () => import('../views/SignUp/Email.vue'),
    props: (route) => ({
      email: route.query.email,
      referrer: route.query.referrer,
    }),
    meta: { pageTitle: 'Sign Up', doesNotRequireAuthentication: true },
  },
  {
    path: '/sign-up/code',
    name: 'SignUpVerification',
    component: () => import('../views/SignUp/Verification.vue'),
    props: (route) => ({ email: route.query.email, code: route.query.code }),
    meta: {
      pageTitle: 'Sign Up Verification',
      doesNotRequireAuthentication: true,
      checkUserAndCompanyDetails: true,
    },
  },
  {
    path: '/sign-up/details',
    name: 'SignUpDetails',
    component: () => import('../views/SignUp/Details.vue'),
    props: (route) => ({ email: route.query.email }),
    meta: { pageTitle: 'Sign Up Details', allowAuthentication: true },
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/LandingPage.vue'),
  },
  {
    path: '/carriers/lane-search',
    name: 'CarriersLaneSearch',
    meta: { pageTitle: 'Lane Search' },
    component: () => import('../views/Carriers/LaneSearch.vue'),
  },

  {
    path: '/carriers/lane-search-results',
    name: 'CarriersLaneSearchResults',
    meta: { pageTitle: 'Lane Search Results' },
    component: () => import('../views/Carriers/LaneSearchResults.vue'),
  },
  {
    path: '/carriers/search-results',
    name: 'CarriersSearchResults',
    meta: { pageTitle: 'Carrier Search Results' },
    component: () => import('../views/Carriers/SearchResults.vue'),
  },
  // This really shouldn't be called global search but instead something
  // like Radius search or just plane carrier search
  {
    path: '/carriers/global-search',
    name: 'GlobalSearch',
    meta: { pageTitle: 'Carrier Search' },
    component: () => import('../views/Carriers/GlobalSearch.vue'),
  },
  {
    path: '/carriers/contact-search',
    name: 'ContactSearch',
    meta: { pageTitle: 'Contact Search' },
    component: () => import('../views/Carriers/ContactSearch.vue'),
    props: (route) => ({ email: route.query.email, phone: route.query.phone }),
  },
  {
    path: '/carriers/Mine',
    name: 'CarriersMine',
    meta: { pageTitle: 'My Carriers' },
    component: () => import('../views/Carriers/Mine.vue'),
  },
  {
    path: '/carriers/connections',
    name: 'CarriersConnections',
    meta: { pageTitle: 'Connections' },
    component: () => import('../views/Broker/Carriers/Connections.vue'),
  },
  {
    path: '/carriers/my-carriers',
    name: 'MyCarriers',
    meta: { pageTitle: 'My Carriers' },
    component: () => import('../views/Broker/Carriers/MyCarriers.vue'),
  },
  {
    path: '/carriers/rate-confirmations',
    name: 'Rate Confirmations',
    meta: { pageTitle: 'Rate Confirmations' },
    component: () => import('../views/RateConfirmations/RateConsIndexPage.vue'),
  },
  {
    path: '/carriers/rate-confirmations/:id',
    name: 'Rate Confirmation Detail',
    meta: { pageTitle: 'Rate Confirmation Detail' },
    component: () =>
      import('../views/Broker/Carriers/RateConfirmationShow.vue'),
  },
  {
    path: '/carriers/rate-confirmations/emails',
    name: 'Rate Confirmation Emails',
    meta: { pageTitle: 'Rate Confirmation Emails' },
    component: () =>
      import('../views/Broker/Carriers/RateConfirmationEmailsIndex.vue'),
  },
  {
    path: '/carriers/rate-confirmations/emails/:id',
    name: 'Rate Confirmation Email Detail',
    meta: { pageTitle: 'Rate Confirmation Email Detail' },
    component: () =>
      import('../views/Broker/Carriers/RateConfirmationEmailShow.vue'),
  },
  {
    path: '/carriers/saved-searches',
    name: 'CarriersSavedSearches',
    meta: { pageTitle: 'Saved Searches' },
    component: () => import('../views/Carriers/SavedSearches.vue'),
  },
  {
    path: '/carriers/:id/:tab?',
    name: 'CarriersShow',
    meta: { pageTitle: 'Carrier Detail' },
    component: () => import('../views/wrapper/Show.vue'),
  },
  {
    path: '/vehicles',
    name: 'VehicleSearch',
    meta: { pageTitle: 'Vehicle Search' },
    component: () => import('../views/Vehicles/VehicleSearch.vue'),
  },
  {
    path: '/vehicles/:id',
    // alias: "/vehicles/:id?by_vin=true",
    name: 'VehicleShow',
    meta: { pageTitle: 'Vehicle Show' },
    component: () => import('../views/Vehicles/VehicleShow.vue'),
  },
  {
    path: '/my-account',
    name: 'MyAccount',
    meta: { pageTitle: 'My Account', allowExpiredUsers: true },
    component: () => import('../views/wrapper/MyAccount.vue'),
  },
  {
    path: '/company_change_orders/:id',
    name: 'CompanyChangeOrdersShow',
    meta: { pageTitle: 'Company Change Order' },
    component: () => import('../views/CompanyChangeOrders/Show.vue'),
  },
  {
    path: '/alerts',
    name: 'Alerts',
    meta: { pageTitle: 'Alerts List' },
    component: () => import('../views/Alerts/AlertsListPage.vue'),
  },
  {
    path: '/alerts/:id',
    name: 'AlertDetails',
    meta: { pageTitle: 'Alert Detail', shortTitle: 'Alert' },
    component: () => import('../views/Alerts/AlertDetailsPage.vue'),
  },
  {
    path: '/loads',
    name: 'Loads',
    meta: { pageTitle: 'Loads List' },
    component: () => import('../views/Loads/LoadsListPage.vue'),
  },
  {
    path: '/loads/:id',
    name: 'LoadDetails',
    meta: { pageTitle: 'Load Detail', shortTitle: 'Load' },
    component: () => import('../views/Loads/LoadDetailsPage.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    meta: { pageTitle: 'Page Not Found' },
    component: () => import('../views/NotFound.vue'),
  },
  {
    path: '/exchange',
    name: 'Exchange',
    meta: { pageTitle: 'Exchange' },
    component: () => import('../views/Exchange/ExchangeDashboard.vue'),
  },
  {
    path: '/offers',
    name: 'Offers',
    meta: { pageTitle: 'Offers' },
    component: () => import('../views/Offers.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // For stringifying the lane search results into query params
  stringifyQuery: (query) => {
    return qs.stringify(query);
  },
  // always scroll to top on new route

  scrollBehavior(to, from, savedPosition) {
    if (to.name === from.name) {
      return savedPosition ?? undefined;
    }
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  const title = to.params.id
    ? `${to.meta.shortTitle || to.meta.pageTitle}: ${to.params.id}`
    : tabTitle + ' - ' + (to.meta.pageTitle || to.name);
  document.title = title;
  let redirectUrlAfterSignin = JSON.parse(
    localStorage.getItem('redirect_url_after_sigin')
  );
  await store.dispatch('users/refreshCurrentUser');
  let currentUser = store.state.users.currentUser;
  await Promise.all([
    store.dispatch('users/refreshCurrentFeatureFlags', currentUser),
    store.dispatch('users/refreshCurrentInquiries'),
  ]);

  // Initialize Grafana Faro if feature flag is enabled
  // User is set via setCurrentUser mutation in users.js
  // If called before init, it queues and sets after initialization
  const { initializeGrafanaFaroIfEnabled } = await import('@/services/grafana');
  initializeGrafanaFaroIfEnabled(store.state.users.featureFlags);

  let currentCompany = currentUser?.company;
  const canConnect = currentUser?.paywall?.can_connect ?? false;
  const canRule = currentUser?.paywall?.can_rule ?? false;
  const canLaneSearch = currentUser?.paywall?.can_lane_search ?? false;
  const canViewTFX = currentUser?.scopes?.includes('view_tfx') ?? false;
  const canViewLoads =
    currentUser?.paywall?.can_load_dashboard &&
    (currentUser?.scopes?.includes('view_loads') ||
      currentUser?.scopes?.includes('manage_loads') ||
      currentUser?.scopes?.includes('view_tickets') ||
      currentUser?.scopes?.includes('manage_tickets') ||
      currentUser?.scopes?.includes('manage_tickets_and_notes'));
  const canViewLoadDetails =
    (currentUser?.paywall?.can_load_dashboard ||
      currentUser?.paywall?.can_post_loads) &&
    (currentUser?.scopes?.includes('view_loads') ||
      currentUser?.scopes?.includes('manage_loads') ||
      currentUser?.scopes?.includes('view_tickets') ||
      currentUser?.scopes?.includes('manage_tickets') ||
      currentUser?.scopes?.includes('manage_tickets_and_notes'));
  const canViewLoadLockAlerts =
    currentUser?.paywall?.can_load_dashboard &&
    (currentUser?.scopes?.includes('view_tickets') ||
      currentUser?.scopes?.includes('manage_tickets') ||
      currentUser?.scopes?.includes('manage_tickets_and_notes'));
  const isInsuranceCompanyType = store.getters['users/isInsuranceCompanyType'];

  const isInsuranceProducer =
    currentUser?.company?.company_type === 'insurance_producer' &&
    (currentUser?.scopes?.includes('view_tickets') ||
      currentUser?.scopes?.includes('manage_tickets'));

  // If the user tries to log in to Watchdog without a Watchdog plan, redirect to Highway.
  // If the user tries to log in to Highway with a Watchdog plan, redirects to Watchdog.

  let latestInquiryStatus = store.getters['users/inquiryStatus'];
  if (latestInquiryStatus === 'under_review') {
    next({ name: 'IDVFailedVerification' });
  }

  const currentHost = window.location.host;
  const isWatchdogActive = currentUser?.paywall?.is_watchdog;

  function determineTargetSubdomain() {
    if (typeof isWatchdogActive === 'undefined') {
      return null;
    }

    if (currentHost.includes('tiawatchdog') && !isWatchdogActive) {
      return 'highway';
    } else if (currentHost.includes('highway') && isWatchdogActive) {
      return 'tiawatchdog';
    } else {
      return null;
    }
  }

  const targetSubdomain = determineTargetSubdomain();

  if (targetSubdomain) {
    const newURL = currentHost.replace(/tiawatchdog|highway/, targetSubdomain);
    window.location.href = `https://${newURL}/broker`;
  }

  // If the user is a Watchdog user and has no more full carrier profile views, make sure that they cannot access Lane Searches.
  if (currentUser?.paywall?.is_watchdog) {
    const restrictedRoutes = [
      'CarriersLaneSearchResults',
      'CarriersLaneSearch',
      'ContactSearch',
      'CarriersMine',
      'CarriersSavedSearches',
      'VehicleSearch',
    ];
    if (
      !currentUser?.watchdog_limits?.can_carrier_search_for_watchdog &&
      restrictedRoutes?.includes(to.name?.trim())
    ) {
      return next({ name: 'Home' });
    }
  }

  if (store.getters['users/hideMyCarriersTab']) {
    const restrictedRoutes = ['CarriersMine', 'MyCarriers'];
    if (restrictedRoutes?.includes(to.name?.trim())) {
      return next({ name: 'Home' });
    }
  }

  if (currentUser?.company?.hide_vehicle_search) {
    const restrictedRoutes = ['VehicleSearch', 'VehicleShow'];

    if (restrictedRoutes?.includes(to.name?.trim())) {
      return next({ name: 'Home' });
    }
  }

  if (!canLaneSearch) {
    const restrictedRoutes = [
      'CarriersLaneSearchResults',
      'CarriersLaneSearch',
    ];
    if (restrictedRoutes?.includes(to.name?.trim())) {
      return next({ name: 'Home' });
    }
  }

  const enableOffersManagement =
    store.state.users.featureFlags?.fe_enable_broker_offers_management?.enabled;

  if (!enableOffersManagement) {
    const restrictedRoutes = ['Offers'];

    if (restrictedRoutes.includes(to.name)) {
      return next({ name: 'Home' });
    }
  }

  if (!canViewTFX) {
    const restrictedRoutes = ['Exchange', 'ExchangeLoadDetail'];
    if (restrictedRoutes?.includes(to.name?.trim())) {
      return next({ name: 'Home' });
    }
  }
  if (!canViewLoads) {
    const restrictedRoutes = ['Loads', 'Alerts'];
    if (restrictedRoutes?.includes(to.name?.trim())) {
      return next({ name: 'Home' });
    }
  }
  if (isInsuranceProducer) {
    const restrictedRoutes = ['Loads'];
    if (restrictedRoutes?.includes(to.name?.trim())) {
      return next({ name: 'Home' });
    }
  }
  if (!canViewLoadDetails || isInsuranceProducer) {
    const restrictedRoutes = ['LoadDetails'];
    if (restrictedRoutes?.includes(to.name?.trim())) {
      return next({ name: 'Home' });
    }
  }
  if (!canViewLoadLockAlerts && !isInsuranceProducer) {
    const restrictedRoutes = ['Alerts'];
    if (restrictedRoutes?.includes(to.name?.trim())) {
      return next({ name: 'Home' });
    }
  }
  if (isInsuranceCompanyType) {
    const restrictedRoutes = ['Loads'];
    if (restrictedRoutes?.includes(to.name?.trim())) {
      return next({ name: 'Home' });
    }
  }

  if (!canViewLoadLockAlerts && !isInsuranceProducer) {
    const restrictedRoutes = ['AlertDetails'];
    if (restrictedRoutes?.includes(to.name?.trim())) {
      return next({ name: 'Home' });
    }
  }

  if (
    !currentUser?.scopes?.includes?.('manage_rate_confirmations') &&
    !currentUser?.scopes?.includes?.('manage_my_rate_confirmations')
  ) {
    const restrictedRoutes = ['Rate Confirmations'];

    if (restrictedRoutes?.includes(to.name?.trim())) {
      return next({ name: 'Home' });
    }
  }

  // Redirect carriers and dispatcher services back to /onboarding
  // if (currentUser && currentCompany?.company_type != 'broker' ) {
  //   return window.location = `${process.env.API_URL}/onboarding`;
  // }

  // First check if user needs to enter name or company, but only if coming from /sign-up/code or /login/code
  if (from.meta.checkUserAndCompanyDetails) {
    if (
      currentUser?.company?.id == null ||
      currentUser?.company?.status == null
    ) {
      if (to.name == 'SignUpDetails') {
        return next();
      } else {
        localStorage.setItem('redirect_url_after_sigin', JSON.stringify(to));
        //If the user comes from the /login means that you have pressed the Try Again button,
        // which makes a call to the JWT and so the routing conditions are traversed.
        if (window.history.state.back?.slice(0, 6) !== '/login') {
          return next({ name: 'SignUpDetails' });
        }
      }
    } else if (
      currentUser?.first_name == null ||
      currentUser?.last_name == null
    ) {
      // User does not have a first or last name
      if (to.name == 'Required Information') {
        return next();
      } else {
        localStorage.setItem('redirect_url_after_sigin', JSON.stringify(to));
        return next({ name: 'Required Information' });
      }
    }
  }

  if (to.meta.doesNotRequireAuthentication) {
    if (currentUser?.id > 0) {
      return next({ name: 'Home' });
    }
    return next();
  }

  // Store the URL where the user is trying to go in the event
  // they are unable

  // Try and get the user from state and if not in state,
  // authenticate with the server to get the authenticated user
  if (currentUser?.id == null) {
    localStorage.setItem('redirect_url_after_sigin', JSON.stringify(to));
    return next({ name: 'Login' });
  }

  // if (from.meta.doesNotRequireAuthentication && to.meta.allowAuthentication) {
  //   return next();
  //   // The user is logged in but if they don't have a company
  //   // we need them to update their company details
  //   // if (to.name == "SignUpDetails" || to.name == "Required Information") {
  //   //   return next();
  //   // } else if ((currentUser.company?.id == null || currentUser.company?.status == null) && to.name !== "SignUpDetails") {
  //   //   localStorage.setItem('redirect_url_after_sigin', JSON.stringify(to))
  //   //   return next({ name: "SignUpDetails" })
  //   // } else if ((currentUser?.first_name == null || currentUser?.last_name == null) && to.name !== "Required Information") {
  //   //   // User does not have a first or last name
  //   //   localStorage.setItem('redirect_url_after_sigin', JSON.stringify(to))
  //   //   return next({ name: "Required Information" });
  //   // }
  // }

  // If broker portal, check if broker company type, else redirect to /onboarding
  const allowedCompanyTypes = [
    'broker',
    'insurance_producer',
    'insurance_insurer',
  ];
  if (
    !currentCompany ||
    !allowedCompanyTypes.includes(currentCompany?.company_type)
  ) {
    window.location.href = process.env.ONBOARDING_REDIRECT;
  }
  if (canConnect) {
    localStorage.removeItem('redirect_url_after_sigin');
    if (redirectUrlAfterSignin) {
      return next(redirectUrlAfterSignin);
    }
    return next();
  }

  // Depending on portal, show correct version of CarriersMine or CarriersConnections
  if (!canRule) {
    if (to.name == 'CarriersConnections') {
      return next({ name: 'CarriersMine' });
    }
  } else {
    if (to.name == 'CarriersMine') {
      return next({ name: 'CarriersConnections' });
    }
  }

  // Allow the user to get to billing pages
  if (to.meta.allowExpiredUsers) {
    return next();
  }

  // If their trial is expired, send them to the paywall
  if (currentCompany?.status == 'subscription_or_trial_expired') {
    localStorage.setItem('redirect_url_after_sigin', JSON.stringify(to));
    return next({ path: '/my-account', query: { tab: 4 } });
  }

  // They are logged in, have registered a company, and have
  // and active plan status.
  localStorage.removeItem('redirect_url_after_sigin');
  if (redirectUrlAfterSignin) {
    return next(redirectUrlAfterSignin);
  }
  return next();
});

// Track page views in Grafana Faro
router.afterEach(async (to) => {
  const { setGrafanaFaroView } = await import('@/services/grafana');
  setGrafanaFaroView(to.name || to.path, {
    path: to.path,
    fullPath: to.fullPath,
  });
});

export default router;
